<div class="not-found-wrapper">
  <div class="not-found-card">
    <img src="assets/gail-logo.png" alt="GAIL Logo" class="not-found-logo" />
    <h1>404</h1>
    <h2>Page Not Found</h2>
    <p>
      Sorry, the page you are looking for does not exist<br>
      Please check the URL or return to the homepage.
    </p>
    <button class="btn btn-success" (click)="goHome()">Go to Home</button>
  </div>
</div>
